import { render, staticRenderFns } from "./ZoneLmsProfile.vue?vue&type=template&id=511a1aa8&scoped=true&"
import script from "./ZoneLmsProfile.vue?vue&type=script&lang=js&"
export * from "./ZoneLmsProfile.vue?vue&type=script&lang=js&"
import style0 from "./ZoneLmsProfile.vue?vue&type=style&index=0&id=511a1aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a1aa8",
  null
  
)

export default component.exports